export enum StatoDump {
  'NUOVO' = 1,
  'VISIONATO',
  'ANALIZZATO',
}
export enum TipologiaDump {
  'NESSUNO' = 1,
  'INFO NON SUFFICIENTI',
  'SATURAZIONE GDI',
  'ERRORE SEGMENTO',
  'FILE MANCANTE',
  'SATURAZIONE MEMORIA',
  'DIPENDENZA CICLICA',
  'TEMPLATE INVENTOR CORROTTO',
}
